<template>
  <div
    class="td-content"
    v-html="header.formatter(data, data[header.field], header.field)"
  />
</template>

<script>
export default {
  name: "wt-raw-html-row",
  props: {
    data: {
      type: Object,
    },
    header: {
      type: Object,
    },
  },
};
</script>